import { UserContextProps } from '@/contexts/userContext/User.context.ts';

export const userIsSenderOrReceiver = (params: {
  emailToVerify: string;
  user: UserContextProps;
}) => {
  const { emailToVerify, user } = params;
  if (user.email === emailToVerify) {
    return user.lastName + ' ' + user.firstName;
  }
  return emailToVerify;
};
